// src/pages/BlogPage.jsx
import React from 'react';
import PageHeader from './PageHeader'; // Adjust path if needed
import { useLanguage } from '../../context/LanguageContext'; // Adjust path if needed
import { FaCalendarAlt, FaUser, FaHeart, FaClock } from 'react-icons/fa';

const BlogPage = () => {
  const { language } = useLanguage();

  const t = {
    English: {
      pageHeaderTitle: "Blog",
      mainTitle: "Matrimony Tips & Love Stories",
      subtitle: "Expert advice, cultural insights, and heartfelt stories to help you find and nurture lifelong love. From profile tips to wedding traditions, we've got you covered.",
      readMore: "Read More",
      readingTime: "5 min read",
      postedOn: "Posted on",
      byAuthor: "By Kalyana Matrimony Team",
      blogs: [
        {
          id: 1,
          title: "How to Create an Attractive Matrimony Profile That Gets Noticed",
          excerpt: "In today's digital age, your matrimony profile is often the first impression you make. A genuine, well-written bio combined with clear, recent photos can significantly increase your chances of finding the right match. Learn how to highlight your personality, family values, career goals, and hobbies authentically. Avoid common mistakes like outdated photos or vague descriptions. We share step-by-step tips used by thousands of successful couples on Kalyana Matrimony.",
          date: "December 10, 2025",
          image: "https://c8.alamy.com/comp/A3F8RN/young-couple-sitting-on-a-mat-and-looking-at-a-laptop-A3F8RN.jpg" // Couple looking at laptop
        },
        {
          id: 2,
          title: "Understanding Horoscope Matching (Jathaka Porutham) in Tamil Weddings",
          excerpt: "Horoscope matching is a cherished tradition in Tamil culture, ensuring harmony and prosperity in marriage. There are 10 key poruthams (matches) like Dina, Gana, Mahendra, and Rajju that astrologers check. Discover what each porutham means, why some are more important than others, and how modern couples balance tradition with personal choice. Includes real examples from happy Kalyana Matrimony couples.",
          date: "November 28, 2025",
          image: "https://www.astrosage.com/tamil/images/thirumana-porutham.jpg" // Horoscope matching chart
        },
        {
          id: 3,
          title: "First Meeting Tips: Making a Great Impression in Arranged Marriages",
          excerpt: "The first meeting with a potential partner and their family can feel nerve-wracking, but preparation makes it memorable. Dress respectfully in traditional attire, prepare thoughtful questions about values and lifestyle, and focus on genuine conversation rather than just appearances. We cover dos and don'ts, body language tips, and how to involve families positively – based on experiences shared by our successful couples.",
          date: "November 15, 2025",
          image: "https://www.bollywoodshaadis.com/img/article-l-2016512512015843318000.jpg" // First meeting with family
        },
        {
          id: 4,
          title: "The Importance of Family Involvement in Arranged Marriages",
          excerpt: "In Indian culture, marriage unites two families, not just two individuals. Early family involvement builds trust, shared values, and lifelong support systems. Learn how open discussions with parents about expectations lead to smoother journeys and happier marriages. Real stories from couples who credit family guidance for their successful unions on Kalyana Matrimony.",
          date: "October 30, 2025",
          image: "https://images.squarespace-cdn.com/content/v1/5bdb8d677e3c3aa608ef69bf/a9e8b945-004a-4fb6-af23-ae6513f693ab/MonisCorey-467_Mehndi-adfcfac6c7674fc59301cdcddf65df07.jpeg" // Happy family at wedding event
        },
        {
          id: 5,
          title: "Building Trust Through Honest Communication in Relationships",
          excerpt: "Strong communication is the cornerstone of every lasting marriage. Discussing expectations, dreams, finances, and family roles openly from the start prevents misunderstandings later. Tips include active listening, expressing appreciation daily, and handling disagreements respectfully. Discover how couples on Kalyana Matrimony turned honest talks into unbreakable bonds.",
          date: "October 20, 2025",
          image: "https://static.toiimg.com/photo/https://static.toiimg.com/thumb/msid-115691756,width-1070,height-580,imgsize-342746,resizemode-75,overlay-toi_sw,pt-32,y_pad-500/photo.jpg" // Happy couple talking
        },
        {
          id: 6,
          title: "Celebrating Love: Modern Twists on Traditional Tamil Weddings",
          excerpt: "Today's Tamil weddings beautifully blend age-old customs with contemporary elements. From eco-friendly decor to personalized vows, couples are making traditions their own while honoring culture. Explore inspiring ideas from recent Kalyana Matrimony weddings that mixed classic rituals with modern touches for unforgettable celebrations.",
          date: "October 05, 2025",
          image: "https://images.pexels.com/photos/15748379/pexels-photo-15748379.jpeg?cs=srgb&dl=pexels-dhilipstudio-15748379.jpg&fm=jpg" // Beautiful wedding couple
        }
      ]
    },
    Tamil: {
      pageHeaderTitle: "வலைப்பதிவு",
      mainTitle: "திருமண குறிப்புகள் & காதல் கதைகள்",
      subtitle: "வாழ்நாள் முழுவதும் நிலைத்து நிற்கும் காதலை கண்டறியவும் வளர்க்கவும் நிபுணர் ஆலோசனைகள், கலாச்சார நுணுக்கங்கள் மற்றும் இதயத்தைத் தொடும் கதைகள். சுயவிவர குறிப்புகள் முதல் திருமண பாரம்பரியங்கள் வரை உங்களுக்கு உதவுகிறோம்.",
      readMore: "மேலும் படிக்க",
      readingTime: "5 நிமிட வாசிப்பு",
      postedOn: "வெளியிடப்பட்டது",
      byAuthor: "Kalyana Matrimony குழு எழுதியது",
      blogs: [
        {
          id: 1,
          title: "கவனத்தை ஈர்க்கும் திருமண சுயவிவரத்தை உருவாக்குவது எப்படி",
          excerpt: "இன்றைய டிஜிட்டல் யுகத்தில் உங்கள் சுயவிவரமே முதல் அபிப்ராயம். உண்மையான வாழ்க்கை வரலாறு, தெளிவான புகைப்படங்களுடன் சரியான இணையை கண்டறிய வாய்ப்பை அதிகரிக்கும். உங்கள் ஆளுமை, குடும்ப மதிப்புகள், தொழில் இலக்குகளை எப்படி உண்மையாக வெளிப்படுத்துவது என்பதை அறிக. பழைய புகைப்படங்கள் போன்ற பொதுவான தவறுகளை தவிர்க்கவும்.",
          date: "டிசம்பர் 10, 2025",
          image: "https://c8.alamy.com/comp/A3F8RN/young-couple-sitting-on-a-mat-and-looking-at-a-laptop-A3F8RN.jpg"
        },
        {
          id: 2,
          title: "தமிழ் திருமணங்களில் ஜாதக பொருத்தம் புரிதல்",
          excerpt: "தமிழ் கலாச்சாரத்தில் ஜாதக பொருத்தம் மகிழ்ச்சியான திருமணத்திற்கு உத்தரவாதம் அளிக்கும் பாரம்பரியம். தினம், கணம், மகேந்திரம் போன்ற 10 முக்கிய பொருத்தங்கள் உள்ளன. ஒவ்வொன்றின் பொருள், முக்கியத்துவம் மற்றும் நவீன தம்பதிகள் எப்படி சமநிலைப்படுத்துகிறார்கள் என்பதை அறிக.",
          date: "நவம்பர் 28, 2025",
          image: "https://www.astrosage.com/tamil/images/thirumana-porutham.jpg"
        },
        {
          id: 3,
          title: "முதல் சந்திப்பு குறிப்புகள்: ஏற்பாட்டு திருமணத்தில் சிறந்த அபிப்ராயம் உருவாக்குதல்",
          excerpt: "சாத்தியமான துணையுடனான முதல் சந்திப்பு பதட்டமாக இருக்கலாம். பாரம்பரிய உடையில் மரியாதையாக உடுத்தி, மதிப்புகள் பற்றிய கேள்விகளை தயாரித்து, உண்மையான உரையாடலில் கவனம் செலுத்துங்கள். குடும்பத்தை எப்படி சிறப்பாக ஈடுபடுத்துவது என்பதை அறிக.",
          date: "நவம்பர் 15, 2025",
          image: "https://www.bollywoodshaadis.com/img/article-l-2016512512015843318000.jpg"
        },
        {
          id: 4,
          title: "ஏற்பாட்டு திருமணங்களில் குடும்ப ஈடுபாட்டின் முக்கியத்துவம்",
          excerpt: "இந்திய கலாச்சாரத்தில் திருமணம் இரு குடும்பங்களை இணைக்கும். ஆரம்பத்திலேயே குடும்ப ஈடுபாடு நம்பிக்கையையும் வலுவான ஆதரவையும் உருவாக்கும். எதிர்பார்ப்புகள் பற்றிய திறந்த உரையாடல்கள் மகிழ்ச்சியான திருமணத்திற்கு வழிவகுக்கும் என்பதை உண்மை கதைகள் மூலம் அறிக.",
          date: "அக்டோபர் 30, 2025",
          image: "https://images.squarespace-cdn.com/content/v1/5bdb8d677e3c3aa608ef69bf/a9e8b945-004a-4fb6-af23-ae6513f693ab/MonisCorey-467_Mehndi-adfcfac6c7674fc59301cdcddf65df07.jpeg"
        },
        {
          id: 5,
          title: "நேர்மையான தொடர்பு மூலம் உறவுகளில் நம்பிக்கை உருவாக்குதல்",
          excerpt: "வலுவான தொடர்பு எந்த திருமணத்தின் அடித்தளம். எதிர்பார்ப்புகள், கனவுகள், நிதி பற்றிய திறந்த உரையாடல்கள் தவறான புரிதல்களை தடுக்கும். செயலில் கேட்டல், தினசரி பாராட்டு போன்ற குறிப்புகளை அறிக.",
          date: "அக்டோபர் 20, 2025",
          image: "https://static.toiimg.com/photo/https://static.toiimg.com/thumb/msid-115691756,width-1070,height-580,imgsize-342746,resizemode-75,overlay-toi_sw,pt-32,y_pad-500/photo.jpg"
        },
        {
          id: 6,
          title: "காதலை கொண்டாடுதல்: பாரம்பரிய தமிழ் திருமணங்களில் நவீன திருப்பங்கள்",
          excerpt: "இன்றைய தமிழ் திருமணங்கள் பாரம்பரியத்துடன் நவீனத்தை அழகாக கலக்கின்றன. சுற்றுச்சூழல் நட்பு அலங்காரம் முதல் தனிப்பட்ட உறுதிமொழிகள் வரை தம்பதிகள் தங்கள் விருப்பப்படி உருவாக்குகிறார்கள். Kalyana Matrimony திருமணங்களிலிருந்து ஊக்கமளிக்கும் யோசனைகள்.",
          date: "அக்டோபர் 05, 2025",
          image: "https://images.pexels.com/photos/15748379/pexels-photo-15748379.jpeg?cs=srgb&dl=pexels-dhilipstudio-15748379.jpg&fm=jpg"
        }
      ]
    }
  };

  const txt = t[language];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        showBackButton={true} 
        backTo="/" 
        title={txt.pageHeaderTitle} 
      />

      <div className="container mx-auto px-6 py-16">
        <div className="text-center max-w-5xl mx-auto mb-20">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-6">
            {txt.mainTitle}
          </h1>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
            {txt.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {txt.blogs.map(blog => (
            <div
              key={blog.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 flex flex-col group"
            >
              <div className="h-72 overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-7 flex-1 flex flex-col">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 line-clamp-3 group-hover:text-rose-600 transition-colors">
                  {blog.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-1 line-clamp-4 leading-relaxed">
                  {blog.excerpt}
                </p>
                <div className="flex items-center justify-between text-sm text-gray-500 mb-5">
                  <span className="flex items-center gap-2">
                    <FaCalendarAlt className="text-rose-500" /> {txt.postedOn} {blog.date}
                  </span>
                  <span className="flex items-center gap-2">
                    <FaClock className="text-rose-500" /> {txt.readingTime}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500 flex items-center gap-2">
                    <FaUser className="text-rose-500" /> {txt.byAuthor}
                  </span>
                  <button className="inline-flex items-center gap-2 text-rose-600 font-bold hover:text-rose-700 transition-colors">
                    {txt.readMore} <FaHeart className="text-base group-hover:scale-125 transition-transform" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;